import { gql } from "apollo-boost"

export default gql`
  subscription ChatRoomMessageIsReadUpdated($chatRoomId: ID!) {
    chatRoomMessageIsReadUpdated(chatRoomId: $chatRoomId) {
      chatRoomId
      chatMessages {
        id
      }
    }
  }
`
